<template>
  <div>
    <v-btn fab small flat class="ma-0" @click="show = true"><v-icon small>edit</v-icon></v-btn>
    <v-dialog v-model="show" v-if="icebreaker" :key="timestamp" max-width="1000" persistent>
      <v-card>
        <v-card-text v-if="show">
          <div
            class="form-control"
            style="border-bottom: 1px solid #eee; padding: 10px"
            :class="{ 'has-error': errors.has('buttonName') }"
          >
            <input
              type="text"
              :data-vv-as="$t('Button Name')"
              data-vv-name="buttonName"
              name="buttonName"
              id="buttonName"
              class="form-control"
              :placeholder="$t('Button Name')"
              v-model="icebreaker.question"
              style="width: 100%"
              v-validate="'required'"
              @keyup="onChange"
              maxlength="30"
            />
            <span class="text-error" v-show="errors.has('buttonName')">{{
              errors.first('buttonName')
            }}</span>
          </div>

          <div style="margin-bottom: 15px; margin-top: 15px">
            {{
              $t(
                'If customer clicks this button, it will send this message to your customer (you can edit the answer in conversation page)'
              )
            }}
          </div>
          <div class="text-xs-center">
            <a
              href="javascript:void(0);"
              class="btn-advanced"
              @click="showAdvanced = !showAdvanced"
            >
              {{ $t('Advanced') }}
              <i
                class="fa"
                :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
              />
            </a>
          </div>
          <template v-if="showAdvanced">
            <div
              class="form-control"
              :class="{ 'has-error': errors.has('buttonValue') }"
              style="margin-top: 15px"
            >
              <input
                type="text"
                key="button-value"
                :data-vv-as="$t('Text')"
                :data-vv-name="'buttonValue'"
                class="form-control"
                :placeholder="$t('Text')"
                style="width: 100%"
                v-model="icebreaker.payload"
                v-validate="'required'"
              />
              <span class="text-error" v-show="errors.has('buttonValue')">{{
                errors.first('buttonValue')
              }}</span>
            </div>
          </template>
          <div class="text-xs-center mt-3">
            <v-btn outline color="grey" @click="onCancel">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn depressed color="primary" @click="onSave">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ManageIceBreaker from './ManageIceBreaker.js'

export default {
  mixins: [ManageIceBreaker]
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/EditIceBreaker.vue